import React, { useEffect, useState } from 'react';
import {  Col, Input, Layout, Modal, notification, Row, Table } from 'antd';
import { updateBooking, updateBookingLoading } from '../../actions/bookingActions';
import { connect } from 'react-redux';

function BookingDetails(props) {
    const { bookingId = '', discountAmount = '', totalBill = '', finalBill = '' }=props;
    const data = [{ bookingId, discountAmount, totalBill, finalBill }];
    const [editSessionModal, setEditSessionModal] = useState(false)

    const [selectedSession, setSelectedSession] = useState({totalBill, finalBill, discountAmount})

    const subColumns = [
        {
            title: "Action",
            dataIndex: 'editSession',
            key: 'editSession',
            width: '5%',
            render: (text, record) => {
                return <button className="edit-session-button" onClick={() => {
                    setSelectedSession(record)
                    setEditSessionModal(true)
                }}>Edit</button>
            }
        },
        {
            title: 'Total Bill',
            dataIndex: 'totalBill',
            key: 'totalBill',
            width: "5%",
            render: text => <span>{text ? `₹${text}` : "-"}</span>,
        },
        {
            title: 'Discount Amount',
            dataIndex: 'discountAmount',
            key: 'discountAmount',
            width: "5%",
            render: text => <span>{text ? `₹${text}` : "-"}</span>,
        },
        {
            title: 'Final Bill',
            dataIndex: 'finalBill',
            key: 'finalBill',
            width: "75%",
            render: text => <span>{text ? `₹${text}` : "-"}</span>,
        },

    ];

    const updateSession=()=>{
        // console.log({selectedSession})
        props.updateBooking({ bookingId, finalAmount:selectedSession.finalBill, discount:selectedSession.discountAmount, totalBill: selectedSession.totalBill });
        setSelectedSession({});
        setEditSessionModal(false);
    }

    return (
        <>
            <Layout className="site-layout">
                <div className="patient-table-container">
                    <Table
                        columns={subColumns}
                        dataSource={data}
                    />
                </div>
                <Modal
                    title="Edit Session"
                    open={editSessionModal}
                    onCancel={() => {
                        setSelectedSession(null)
                        setEditSessionModal(false)
                    }}

                    onOk={() => updateSession()}
                >
                    {selectedSession && <>
                        <Row gutter={24} className="row insurance-booking-session">
                            <Col span={12} className="col-6">
                                <label className="session-label">Total Bill</label>
                                <Input value={selectedSession.totalBill} onChange={(e) => setSelectedSession({ ...selectedSession, totalBill: e.target.value })} />
                            </Col>
                            <Col span={12} className="col-6">
                                <label className="session-label">Discount Amount</label>
                                <Input value={selectedSession.discountAmount} onChange={(e) => setSelectedSession({ ...selectedSession, discountAmount: e.target.value })} />
                            </Col>
                        </Row>
                        <Row gutter={24} className="row insurance-booking-session">
                            <Col span={12} className="col-6">
                                <label className="session-label">Final Bill</label>
                                <Input disabled value={selectedSession.finalBill} onChange={(e) => setSelectedSession({ ...selectedSession, finalBill: e.target.value })} />
                            </Col>
                        </Row>
                    </>}
                </Modal>
            </Layout>
        </>
    )
}

const mapStateToProps = (state) => ({
    updateBookingLoadingFlag: state.bookingStore.updateBookingLoading,
    updateBookingRet: state.bookingStore.updateBookingRet,
  });
  
export default connect(mapStateToProps, {
    updateBooking,
    updateBookingLoading
  })(BookingDetails);